export function initLazyImages(root = document) {
    const lazyImages = Array.from(
        root.querySelectorAll('img.lazy')
    );

    if (!('IntersectionObserver' in window)) {
        lazyImages.forEach(img => {
            if (img?.dataset?.src) {
                img.src = img.dataset.src;
            }

            img.classList.remove('lazy');
        });

        return;
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }

            const img = entry.target;

            if (img?.dataset?.src) {
                img.src = img.dataset.src;
            }

            img.classList.remove('lazy');

            observer.unobserve(img);
        });
    });

    lazyImages.forEach(img => {
        if (img instanceof Element) {
            observer.observe(img);
        }
    });
}
